import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase} from "@mui/material";
import TableUrlLookupResult from "../../components/TableUrlLookupResult";
import {useEffect, useState, useRef} from 'react';
import axios from 'axios';
import {API_ENDPOINT_URL} from "../../util/api";
import { getLocalItem } from "../../util/helper";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import _ from 'lodash'; 

const columns = [
    {
      field: "created",
      headerName: "Date",
      flex: 1,
      cellClassName: "name-column--cell"
    },
    {
      field: "user",
      headerName: "User",
      flex: 1
    },
    {
      field: "url",
      headerName: "URL",
      flex: 1
    },
    {
      field: "brand",
      headerName: "Brand",
      flex: 1
    },
    {
      field: "is_phish",
      headerName: "isPhish",
      flex: 1
    },
    {
      field: "feedback",
      headerName: "feedback",
      flex: 1
    },
  ];

// Set options for formatting date and time
const japanTimeOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  timeZone: 'Asia/Tokyo', // Japan timezone
};

const URLLookupResult = () => {
  const [loading, setLoading]= useState(false)
  const token = getLocalItem("key")
  const [searchStartDate, setSearchStartDate] = useState(null);
  const [searchEndDate, setSearchEndDate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [validateDate, setValidateDate]= useState(false);
  const [validateStartDate, setValidateStartDate]= useState(false);
  const [validateEndDate, setValidateEndDate]= useState(false);
  const [validateText, setValidateText]= useState("");
  const [searchRange, setSearchRange] = useState('');

  const [data, setData] = useState([]);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setValidateDate(false);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setValidateDate(false);
  };

  const handleSearch = (searchParamsVar) => {
    const { currentPageChange, sort } = searchParamsVar;
    setCurrentPage(currentPageChange)
    setLoading(true)
    const params = {
      begin_date: searchStartDate,
      end_date: searchEndDate,
      page: currentPageChange,
      ordering: 'id',
    };
    axios.get(`${API_ENDPOINT_URL}/data/lookup-result/`, { params: params, headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          setData(response.data)
        })
        .catch(error => {})
        .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!startDate || !endDate) {
      setSearchRange("");
      setValidateDate(true);
      setValidateStartDate(!startDate)
      setValidateEndDate(!endDate)
      setValidateText('')
      return;
    } else if (startDate&&endDate){
      const diffDate = startDate.diff(endDate, 'days') 
      const valid = diffDate<=0?false:true
      if (valid){
        setValidateText('End date must be greater than the Start date.')
      }
      setValidateStartDate(!startDate)
      setValidateEndDate(!endDate)
      setValidateDate(valid)
    } else{
      setValidateDate(false)
    }
    if(!validateDate){
      const searchStartDateString = new Date(startDate).toLocaleDateString('ja-JP', japanTimeOptions);
      const searchEndDateString = new Date(endDate).toLocaleDateString('ja-JP', japanTimeOptions);
    
      setSearchStartDate(searchStartDateString);
      setSearchEndDate(searchEndDateString);
      const formattedSearchRange = `Usage Results from: ${searchStartDateString} ~ ${searchEndDateString}`;
      setSearchRange(formattedSearchRange);

      setLoading(true)
      const params = {
        begin_date: searchStartDateString,
        end_date: searchEndDateString,
        page: 1,
        ordering: 'id',
      };
      axios.get(`${API_ENDPOINT_URL}/data/lookup-result/`, { params: params, headers: { Authorization: `Bearer ${token}` } })
          .then(response => {
            setData(response.data)
          })
          .catch(error => {})
          .finally(() => setLoading(false));
    }

  }, [startDate, endDate]);

  
  return (
    <Box
      mt="50px"
      sx={{
        width: "95%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
        }}
      >
        <Grid container spacing={0}>
          <Grid item lg={6} sm={12} md={6}>
            <Box>
              <Typography
                variant="h1"
                fontSize={40}
                fontWeight="bold"
                color="#2699fb"
                textAlign="left"
              >
                1URL Usage Results
              </Typography>
            </Box>
          </Grid>

          <Grid item lg={6} sm={12} md={6}>
            <Box
              sx={{
                // width:"100%",
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Typography
                  mr={1}
                  variant="body1"
                  fontSize={20}
                  color="#707070"
                >
                  Date:
                </Typography>
                <DatePicker
                  value={startDate}
                  onChange={handleStartDateChange}
                  label="Start Date *"
                  format="YYYY/MM/DD"
                  slotProps={{ actionBar: { actions: ['today', 'clear',] }}}
                  sx={{
                    ...(validateStartDate && {
                      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid red',
                      },
                    }),
                  }}
                />
                <Typography variant="body1" m={1} fontSize={20} color="#707070">
                  ~
                </Typography>
                <DatePicker
                  value={endDate}
                  onChange={handleEndDateChange}
                  label="End Date *"
                  format="YYYY/MM/DD"
                  slotProps={{ actionBar: { actions: ['today', 'clear'] }}}
                  sx={{
                    ...(validateEndDate && {
                      '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                        border: '1px solid red',
                      },
                    }),
                  }}
                />
                
              </LocalizationProvider>
            </Box>
            {validateDate && (
              <Typography sx={{ color: 'red' }}>
                  {validateText}
              </Typography>
            )}
          </Grid>
          
        </Grid>
        {data ? (
          <Box mt={5} width="100%">
            <TableUrlLookupResult
              searchRange={searchRange}
              rows={data.results}
              columns={columns}
              totalPage={data.last_page_number}
              onSearch={handleSearch}
              loading={loading}
              currentPage={currentPage}
            />
          </Box>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
    // </ThemeProvider>
  );
};

export default URLLookupResult;
